import { Component, Input, ViewEncapsulation } from '@angular/core';
import { navItems } from './../../_nav';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { IntervalObservable } from "rxjs/observable/IntervalObservable";

import { ToasterService, ToasterConfig } from 'angular2-toaster/angular2-toaster';
import { Md5 } from 'ts-md5/dist/md5';
import { ExcelService } from '../../excel.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./../../../scss/vendors/toastr/toastr.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ToasterService]
})

export class DefaultLayoutComponent {
  public rconsulta: any = {
    prestador: null,
    mes: "null",
    ano: "null",
    opt: 71
  }
  private toasterService: ToasterService;

  public toasterconfig: ToasterConfig =
    new ToasterConfig({
      tapToDismiss: true,
      timeout: 5000
    });
  public headers = new HttpHeaders();
  //public navItems = navItems;
  public navItems = [];
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public totalPres = null;
  public totalPresFix = null;
  public element: HTMLElement = document.body;
  public nfADM: any = { gestAt: null, gestNVist: null, complAt: null, compNVist: null };
  public nfADMTotal = null;
  public listaObservacao : any;
  public usuario: any = {
    nome: "",
    idUsuario: "",
    tipo: 0
  }
  public nsenha = "";
  public csenha = "";
  public enfermeira = false;

  constructor(public router: Router, private http: HttpClient, protected storage: LocalStorage, private modalService: BsModalService, toasterService: ToasterService, private excelService: ExcelService) {
    this.toasterService = toasterService;
    this.headers = this.headers.set("Content-Type", "application/json; charset=UTF-8");
    //IntervalObservable.create(10000).subscribe(() => { this.notif(); });
    this.storage.getItem('usuario').subscribe((data) => {

      this.usuario = data;
      this.notif();
      if (data != null) {
        if (data['tipo'] == '1') {
          this.navItems = navItems;
          this.upDados();
        } else if (data['tipo'] == '2') {
          this.enfermeira = true;
          this.rconsulta.prestador = data['prestador'];
          this.navItems = [
            {
              name: 'Dashboard',
              url: '/dashboard',
              icon: 'cui-chart'
            },
            {
              name: 'Cadastro',
              url: '/cadastro',
              icon: 'icon-user-follow',
              badge: {
                variant: 'info',
                text: ''
              }
            },
            {
              name: 'Agenda',
              url: '/agenda',
              icon: 'cui-calendar',
              badge: {
                variant: 'info',
                text: ''
              }
            },
            {
              name: 'Encaminhamento',
              url: '/encaminhar',
              icon: 'cui-calendar',
              badge: {
                variant: 'info',
                text: ''
              }
            },
            {
              name: 'Tabela de Referência',
              url: '/tabelaReferencia',
              icon: 'fa fa-table',
              badge: {
                variant: 'info',
                text: ''
              }
            },{
              name: 'Consulta extra enfermeira',
              url: '/consultaExtraEnfermeira',
              icon: 'fa fa-table',
              badge: {
                variant: 'info'
              }
            }
          ];
        } else if (data['tipo'] == '3') {
          this.navItems = [
            {
              name: 'Dashboard',
              url: '/dashboard',
              icon: 'cui-chart'
            },
            {
              name: 'Cadastro',
              url: '/cadastro',
              icon: 'icon-user-follow',
              badge: {
                variant: 'info',
                text: ''
              }
            },
            {
              name: 'Agenda',
              url: '/agenda',
              icon: 'cui-calendar',
              badge: {
                variant: 'info',
                text: ''
              }
            },
            {
              name: 'Encaminhamento',
              url: '/encaminhar',
              icon: 'cui-calendar',
              badge: {
                variant: 'info',
                text: ''
              }
            }

          ];
        }
        // this.router.navigateByUrl('/dashboard');
      } else {

        //this.navItems = navItems;
        //this.upDados();
      }
    });



    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = document.body.classList.contains('sidebar-minimized')
    });

    this.changes.observe(<Element>this.element, {
      attributes: true
    });
  }
  public upDados() {

    this.http.post(environment.urlApi, JSON.stringify({ opt: 6, id: 1 }), { headers: this.headers }).subscribe(data => {
      if (data != null) {
        if (data['gestantes'] != null) {
          //this.navItems[1].badge.text = data['gestantes'];
          //this.navItems[3].badge.text = data['agenda'];    
        }
      }
    });
  }
  public sair() {

    this.storage.clear().subscribe(() => {
      //window.location.assign("/loading");

      this.router.navigateByUrl('/loading');
    });
    //window.location.assign("/login");
    //window.location.reload();
  }
  public menu() {
    /*
    if (this.usuario['prestador'] != null) {
      this.http.post(environment.urlApi, JSON.stringify({ opt: 41, pres: this.usuario['prestador'] }), { headers: this.headers }).subscribe(data => {

        if (data != null) {
          if (data[0] = "00000") {
            this.totalPres = null;
            this.notif();

          }
        }

      });
    } else {
      this.http.post(environment.urlApi, JSON.stringify({ opt: 45, pres: this.usuario['prestador'] }), { headers: this.headers }).subscribe(data => {
        if (data != null) {
          this.notif();
        }
      });
    }
*/
  }
  obs(item,mod){
    mod.show();
   
  }
  private notif() {

    let post = {
      opt : "getNotificacaiObservacao",
      prestador : this.usuario.prestador
    }
    this.http.post(environment.urlApi, JSON.stringify(post), { headers: this.headers }).subscribe(data => {
      if (data != null) {
        this.listaObservacao = data;
        if( this.listaObservacao.length > 0 ){
          this.nfADMTotal = this.listaObservacao.length  ;
        }
      }
    });


    /*
    if (this.usuario['prestador'] != null) {
      this.http.post(environment.urlApi, JSON.stringify({ opt: 40, pres: this.usuario['prestador'] }), { headers: this.headers }).subscribe(data => {
        if (data['total'] != null) {
          if (data['total'] > 0) {
            this.totalPres = data['total'];
          } else {
            this.totalPres = null;
          }
        }
      });
      this.http.post(environment.urlApi, JSON.stringify({ opt: 42, pres: this.usuario['prestador'] }), { headers: this.headers }).subscribe(data => {
        if (data['total'] != null) {
          if (data['total'] > 0) {
            this.totalPresFix = data['total'];
          } else {
            this.totalPresFix = null;
          }
        }
      });
    } else {
      this.http.post(environment.urlApi, JSON.stringify({ opt: 44 }), { headers: this.headers }).subscribe(data => {
        if (data != null) {
          this.nfADM = data;
          this.nfADM.compNVist = parseInt(this.nfADM.compNVist);
          this.nfADM.gestNVist = parseInt(this.nfADM.gestNVist);
          this.nfADM.complAt = parseInt(this.nfADM.complAt);
          this.nfADM.gestAt = parseInt(this.nfADM.gestAt);
          if (this.nfADM.compNVist == 0 && this.nfADM.gestNVist == 0) {
            this.nfADMTotal = null;

          } else {
            this.nfADMTotal = this.nfADM.compNVist + this.nfADM.gestNVist;
          }

        }
      });
    }*/
  }
  agenda() {
    this.router.navigateByUrl('/agenda');
  }
  trocarSenha(mod) {
    if (this.nsenha.trim() == "" || this.csenha.trim() == "") {
      this.toasterService.pop('error', 'Senha', 'todos os campos são obrigatórios');
    } else if (this.nsenha.trim() != this.csenha.trim()) {
      this.toasterService.pop('warning', 'Senha', 'Os campos devem ser iguais.');
    } else if (this.nsenha.length < 6) {
      this.toasterService.pop('warning', 'Senha', 'a senha deve ter no minimo 6 caracteres.');
    } else if (Md5.hashStr(this.nsenha) == this.usuario.senha) {
      this.toasterService.pop('warning', 'Senha', 'a senha não deve ser igual a senha atual.');
    } else {

      let nsenha = Md5.hashStr(this.nsenha);
      let post: any = { id: this.usuario.idUsuario, senha: nsenha, opt: 61 };
      this.http.post(environment.urlApi, JSON.stringify(post), { headers: this.headers }).subscribe(data => {

        if (data[0] == "00000") {
          this.nsenha = "";
          this.csenha = "";
          this.toasterService.pop('success', 'Senha', 'Senha alterada com sucesso.');
          mod.hide();
        } else {
          this.toasterService.pop('error', 'Senha', 'Falha ao trocar a senha, tente mais tarde.');
        }
      });
    }


    //mod.hide();
  }
  getRelatorioConsulta() {
    this.http.post(environment.urlApi, JSON.stringify(this.rconsulta), { headers: this.headers }).subscribe(data => {
      if (data != null) {
        let dados: any = data;
        if (Object(dados).length > 0) {
          this.excelService.exportAsExcelFile(dados, 'Relatorio de consultas');
        } else {
          this.toasterService.pop('error', 'Relatorio', 'Não existe relatório de consulta disponível nesse período.');
        }
      }
    });
    
  }
}
